import CalendarIcon from "../../../icons/calendarIcon";

const Stats = ({ t }) => {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
      <div className="flex items-center gap-4 p-6 border border-primary rounded-2xl">
        <span className="grid place-content-center size-12 rounded-xl bg-[#514E48CC] ">
          <CalendarIcon fill={"#D1A855"} className={"size-6"} />
        </span>
        <div>
          <p className="mb-2 text-xl font-semibold capitalize">{t("attendees")}</p>
          <p className="text-[32px] font-bold">132</p>
        </div>
      </div>
      <div className="flex items-center gap-4 p-6 border border-primary rounded-2xl">
        <span className="grid place-content-center size-12 rounded-xl bg-[#514E48CC] ">
          <CalendarIcon fill={"#D1A855"} className={"size-6"} />
        </span>
        <div>
          <p className="mb-2 text-xl font-semibold capitalize">{t("absentees")}</p>
          <p className="text-[32px] font-bold">8</p>
        </div>
      </div>
      <div className="flex items-center gap-4 p-6 border border-primary rounded-2xl">
        <span className="grid place-content-center size-12 rounded-xl bg-[#514E48CC] ">
          <CalendarIcon fill={"#D1A855"} className={"size-6"} />
        </span>
        <div>
          <p className="mb-2 text-xl font-semibold capitalize">{t("latecomers")}</p>
          <p className="text-[32px] font-bold">10</p>
        </div>
      </div>
    </div>
  );
};

export default Stats;
